import { useTranslation } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaAngleDown } from "react-icons/fa6";
import classes from "./styles.module.css";

const LANGUAGES: {
    [key: string]: { label: string; flag: string }
} = {
    ar: { label: "Arabic", flag: "🇱🇾" },
    en: { label: "English", flag: "🇬🇧" },
    it: { label: "Italian", flag: "🇮🇹" }
}

interface LangMenuProp {
    className?: string;
}

const LangMenu = ({ className }: LangMenuProp) => {
    const { i18n } = useTranslation();

    const changeLanguageHandle = (lang: string) => {
        i18n.changeLanguage(lang);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }

    const currentLang = LANGUAGES[i18n.language] || { label: i18n.language.toUpperCase(), flag: "" };

    return (
        <Dropdown className={className}>
            <Dropdown.Toggle
                id="dropdown-basic"
                className={classes.lang__btn}
                aria-label="Language Selector"
            >
                <span className={classes.flag}>{currentLang.flag}</span>
                {currentLang.label}
                <FaAngleDown />
            </Dropdown.Toggle>

            <Dropdown.Menu className={classes.lang__dropdown}>
                {Object.entries(LANGUAGES).map(([code, { label, flag }]) => (
                    <Dropdown.Item key={code} onClick={() => changeLanguageHandle(code)}>
                        <span className={classes.flag}>{flag}</span> {label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default LangMenu;
